<div
  class="fieldset"
  [ngClass]="{
    error: hasErrorString(),
    colorChange: showList,
    disabled_input: disabled,
    removeBackground: removeBackground,
  }">
  <div
    *ngIf="legend"
    data-cy="input-select-field-legend"
    class="input-label"
    [ngClass]="{ error: hasErrorString(), selecting: showList, show: showList || inputValue }">
    {{ legend | translate }}
  </div>
  <div class="input-container" #listInput>
    <input
      data-cy="input-select-field"
      [readOnly]="disabled"
      type="text"
      class="name input"
      [(ngModel)]="inputValue"
      (input)="onInput($event.target.value); filterList()"
      [maxlength]="maxLength ? maxLength : 'none'"
      [placeholder]="placeholder && !showList ? (placeholder | translate) : ''"
      (click)="filterList()"
      [ngClass]="{ disabled_input: disabled, selecting: showList }" />
    <mat-icon
      data-cy="input-select-field-dropdown-button"
      svgIcon="arrow-down"
      class="icon"
      [ngClass]="{ disabled_input: disabled }"
      [ngStyle]="{ transform: !showList ? '' : 'rotate(180deg)' }"
      (click)="iconClicked()" />
  </div>
</div>
<ng-container *ngIf="hasErrorString()">
  <div data-cy="input-select-field-error-message" class="error-message">
    {{ getErrorString() | translate }}
  </div>
</ng-container>

<ng-container *ngIf="showList && filteredOptionsArray?.length > 0">
  <div class="list-wrapper" #listContainer>
    <div class="list-container" data-cy="input-select-field-text-suggestion">
      <div
        *ngFor="let item of filteredOptionsArray"
        (click)="$event.stopPropagation(); optionSelected(item)"
        class="list-item">
        <p class="name-container" *ngIf="item">
          <span
            data-cy="input-select-field-dropdown-list-item"
            *ngFor="let namePart of getNameArray(item); index as i"
            [ngClass]="{ highlighted: namePart?.toLowerCase() == inputValue?.toLowerCase() }">
            <ng-container
              *ngIf="getNameArray(item)[i - 1]?.slice(-1) == ' ' || namePart.slice(0, 1) == ' '"
              >&#160;</ng-container
            >
            {{ namePart }}
          </span>
          <span
            class="right-part"
            data-cy="input-select-field-dropdown-list-item-more-text"
            *ngIf="extraListInfo">
            {{ item.extraListInfo }}
          </span>
        </p>
      </div>
    </div>
  </div>
</ng-container>
